module.exports = __webpack_public_path__ + "static/og-image-9c275c556fccb0dbc6078a6367cb1489.png";